export default __webpack_public_path__ + "c8c1a8a.png";